module.exports = __webpack_public_path__ + "img/buy-tree-img.07bb2e2e.png";